import { selectUserProfile } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useUserProfile = () => useSelector(selectUserProfile);

export default useUserProfile;
